
/* ============================== src/components/views/LibraryView.jsx ============================== */
// path: frontend/src/components/views/LibraryView.jsx
/**
 * Объединённый раздел «Шаблоны и черновики». Обе вкладки видны, если
 * у пользователя есть capabilities.accessLibrary (сервер:
 * computeCapabilities → accessLibrary = canCreateTask || canCreateProject).
 *
 * useControlledTab здесь намеренно не используется: у LibraryView нет
 * внешнего наблюдателя, вкладки живут в локальном состоянии и не
 * переживают перезагрузку (как и раньше).
 */
import { useMemo, useState } from "react";
import { Tabs } from "../Tabs";
import { useAuth } from "../../hooks/useAuth";
import TemplatesView from "./TemplatesView";
import DraftsView from "./DraftsView";

const TAB_TEMPLATES = "templates";
const TAB_DRAFTS = "drafts";

export default function LibraryView({ ur, openTask, openProject }) {
  const { capabilities } = useAuth();
  const accessLibrary = Boolean(capabilities.accessLibrary);

  const visibleTabs = useMemo(
    () =>
      accessLibrary
        ? [
            { id: TAB_TEMPLATES, label: "Шаблоны" },
            { id: TAB_DRAFTS, label: "Черновики" },
          ]
        : [],
    [accessLibrary],
  );

  const defaultTab = visibleTabs[0]?.id || TAB_TEMPLATES;
  const [activeTab, setActiveTab] = useState(defaultTab);

  const resolvedTab = visibleTabs.some((t) => t.id === activeTab)
    ? activeTab
    : defaultTab;

  if (!accessLibrary) {
    return (
      <div className="empty-note p-4">Раздел недоступен для вашей роли</div>
    );
  }

  return (
    <div>
      <Tabs tabs={visibleTabs} active={resolvedTab} onChange={setActiveTab} />
      <div hidden={resolvedTab !== TAB_TEMPLATES}>
        <TemplatesView />
      </div>
      <div hidden={resolvedTab !== TAB_DRAFTS}>
        <DraftsView ur={ur} openTask={openTask} openProject={openProject} />
      </div>
    </div>
  );
}
